export { requestStates } from './constants';
export { default as sortListByFuzzyMatch } from './fuzzy-matching';
export { lazyWithRetry } from './lazy-load-with-retry';
export { default as prefixUtilityClasses } from './prefix-utility-classes';
export { usePrevious } from './react-hooks';
export { getAppUrl } from './registry-helpers';

/* accessibilty */
export {
  isWideScreen,
  isEscape,
  isTab,
  isReverseTab,
  getTabbableElements,
  isEnter,
} from './accessibility/index';

/* api */
export { fetchAndUpdateSessionExpiration, apiRequest } from './api/index';

/* cerner */
export { getCernerURL, appointmentsToolLink } from './cerner/index';

/* data */
export { default as objectKeysToCamelCase } from './data/camelCaseObjectKeys';
export { default as checkValidPath } from './data/checkValidPath';
export { default as deconstructPath } from './data/deconstructPath';
export { default as deduplicate } from './data/deduplicate';
export { default as replacementFunctions } from './data/index';
export { default as removeDeeplyEmptyObjects } from './data/removeDeeplyEmptyObjects';
export { default as redactPii } from './data/redactPii';
export { titleCase } from './data/titleCase';

/* date */
export {
  dateFieldToDate,
  formatDateLong,
  formatDateParsedZoneLong,
  formatDateShort,
  formatDateParsedZoneShort,
  timeFromNow,
  isValidDateString,
  formatDowntime,
} from './date/index';

/* environments */
export { default as environment } from './environment/index';
export {
  replaceWithStagingDomain,
  replaceDomainsInData,
} from './environment/stagingDomains';

/* feature-toggles */
export {
  connectFeatureToggle,
  updateFeatureToggleValue,
  useFeatureToggle,
  Toggler,
} from './feature-toggles/index';
export { getFlipperId, generateToken } from './feature-toggles/helpers';
export { default as makeFlipperClient } from './feature-toggles/flipper-client';
export { default as featureFlagNames } from './feature-toggles/featureFlagNames';

/*
 * medical-centers is intentionally NOT re-exported here. Re-exporting it
 * statically pulls vets-json-schema's vaMedicalFacilities.json (~50KB) into
 * every application that imports anything from this barrel. No consumer imports
 * these names from the barrel; import them directly from the subpath instead:
 *   '@department-of-veterans-affairs/platform-utilities/medical-centers'
 */

/* sso */
export {
  SSO_KEEP_ALIVE_ENDPOINT,
  AUTHN_HEADERS,
  AUTHN_KEYS,
  CSP_KEYS,
  CSP_AUTHN,
  SKIP_DUPE_QUERY,
  SKIP_DUPE,
  cernerEnvPrefixes,
  oracleHealthEnvPrefixes,
  eauthEnvironmentPrefixes,
  oktaEnvironmentPrefixes,
} from './sso/constants';
export {
  checkAndUpdateSSOeSession,
  checkAutoSession,
  ssoKeepAliveSession,
} from './sso/index';
export {
  default as keepAliveSSO,
  sanitizeAuthn,
  generateAuthnContext,
  keepAlive,
} from './sso/keepAliveSSO';
export {
  getLoginAttempted,
  setLoginAttempted,
  removeLoginAttempted,
} from './sso/loginAttempted';
export { default as mockKeepAliveSSO } from './sso/mockKeepAliveSSO';
export { logoutUrlSiS } from './oauth/utilities';

/* storage */
export { default as getLocalStorage } from './storage/localStorage';

/* ui */
export { default as asyncLoader } from './ui/asyncLoader';
export { default as DelayedRender } from './ui/DelayedRender';
export {
  displayFileSize,
  focusElement,
  isReactComponent,
  displayPercent,
  formatSSN,
} from './ui/index';
